module.exports = __webpack_public_path__ + "fonts/Libre_Franklin-700-latin-ext14.d035c4a.woff2";